import { createSlice } from "@reduxjs/toolkit";
import { registerUserAsAdmin } from "api/thunk/applications/postActions/registerUserAsAdmin";
import { changeDistanceAsAdmin } from "api/thunk/applications/postActions/changeDistanceAsAdmin";
import { postApplications } from "api/thunk/applications/postActions/postApplications";
import { postApplicationsPwd } from "api/thunk/applications/postActions/postApplicationsPwd";
import { postApplicationsMoney } from "api/thunk/applications/postActions/postApplicationsMoney";
import { postApplicationsInsurance } from "api/thunk/applications/postActions/postApplicationsInsurance";
import { postApplicationsInsurancePromocode } from "api/thunk/applications/postActions/postApplicationsInsurancePromocode";
import { postApplicationsInsurancePwd } from "api/thunk/applications/postActions/postApplicationsInsurancePwd";
import { postApplicationsChangeDistance } from "api/thunk/applications/postActions/postApplicationsChangeDistance";
import { postApplicationsMarathonMark } from "api/thunk/applications/postActions/postApplicationsMarathonMark";
import { postApplicationsMarathonUnmark } from "api/thunk/applications/postActions/postApplicationsMarathonUnmark";
import { getApplicationsById } from "api/thunk/applications/getActions/getApplicationsById";
import { deleteApplicationById } from "api/thunk/applications/deleteActions/deleteApplicationById";
import { getApplicationsMarathonIndividualIssuance } from "api/thunk/applications/getActions/getApplicationsMarathonIndividualIssuance";
import { getApplicationsMarathonCorporateIssuance } from "api/thunk/applications/getActions/getApplicationsMarathonCorporateIssuance";
import { getApplicationsMarathonsExcel } from "api/thunk/applications/getActions/getApplicationsMarathonsExcel";
import { getMyApplications } from "api/thunk/applications/getActions/getMyApplications";
import { getApplicationsMarathonPublic } from "api/thunk/applications/getActions/getApplicationsMarathonPublic";
import { putApplicationsMarathonExcel } from "api/thunk/applications/putActions/putApplicationsMarathonExcel";
import { initialState } from "./initialState";

const applicationsSlice = createSlice({
  name: "applications",
  initialState,
  reducers: {},
  extraReducers: (builder) =>
    builder
      //registerUserAsAdmin
      .addCase(registerUserAsAdmin.pending, (state) => {
        state.registerUserAsAdmin.loading = true;
        state.registerUserAsAdmin.error = null;
      })
      .addCase(registerUserAsAdmin.fulfilled, (state, action) => {
        state.registerUserAsAdmin.loading = false;
        state.registerUserAsAdmin.data = action.payload;
      })
      .addCase(registerUserAsAdmin.rejected, (state, action) => {
        state.registerUserAsAdmin.loading = false;
        state.registerUserAsAdmin.error =
          action.error.message || "Неизвестная ошибка";
      })

      //changeDistanceAsAdmin
      .addCase(changeDistanceAsAdmin.pending, (state) => {
        state.changeDistanceAsAdmin.loading = true;
        state.changeDistanceAsAdmin.error = null;
      })
      .addCase(changeDistanceAsAdmin.fulfilled, (state, action) => {
        state.changeDistanceAsAdmin.loading = false;
        state.changeDistanceAsAdmin.data = action.payload;
      })
      .addCase(changeDistanceAsAdmin.rejected, (state, action) => {
        state.changeDistanceAsAdmin.loading = false;
        state.changeDistanceAsAdmin.error =
          action.error.message || "Неизвестная ошибка";
      })

      //postApplications
      .addCase(postApplications.pending, (state) => {
        state.postApplications.loading = true;
        state.postApplications.error = null;
      })
      .addCase(postApplications.fulfilled, (state, action) => {
        state.postApplications.loading = false;
        state.postApplications.data = action.payload;
      })
      .addCase(postApplications.rejected, (state, action) => {
        state.postApplications.loading = false;
        state.postApplications.error =
          action.error.message || "Неизвестная ошибка";
      })

      //postApplicationsPwd
      .addCase(postApplicationsPwd.pending, (state) => {
        state.postApplicationsPwd.loading = true;
        state.postApplicationsPwd.error = null;
      })
      .addCase(postApplicationsPwd.fulfilled, (state, action) => {
        state.postApplicationsPwd.loading = false;
        state.postApplicationsPwd.data = action.payload;
      })
      .addCase(postApplicationsPwd.rejected, (state, action) => {
        state.postApplicationsPwd.loading = false;
        state.postApplicationsPwd.error =
          action.error.message || "Неизвестная ошибка";
      })

      //postApplicationsMoney
      .addCase(postApplicationsMoney.pending, (state) => {
        state.postApplicationsMoney.loading = true;
        state.postApplicationsMoney.error = null;
      })
      .addCase(postApplicationsMoney.fulfilled, (state, action) => {
        state.postApplicationsMoney.loading = false;
        state.postApplicationsMoney.data = action.payload;
      })
      .addCase(postApplicationsMoney.rejected, (state, action) => {
        state.postApplicationsMoney.loading = false;
        state.postApplicationsMoney.error =
          action.error.message || "Неизвестная ошибка";
      })

      //postApplicationsInsurance
      .addCase(postApplicationsInsurance.pending, (state) => {
        state.postApplicationsInsurance.loading = true;
        state.postApplicationsInsurance.error = null;
      })
      .addCase(postApplicationsInsurance.fulfilled, (state, action) => {
        state.postApplicationsInsurance.loading = false;
        state.postApplicationsInsurance.data = action.payload;
      })
      .addCase(postApplicationsInsurance.rejected, (state, action) => {
        state.postApplicationsInsurance.loading = false;
        state.postApplicationsInsurance.error =
          action.error.message || "Неизвестная ошибка";
      })

      //postApplicationsInsurancePromocode
      .addCase(postApplicationsInsurancePromocode.pending, (state) => {
        state.postApplicationsInsurancePromocode.loading = true;
        state.postApplicationsInsurancePromocode.error = null;
      })
      .addCase(
        postApplicationsInsurancePromocode.fulfilled,
        (state, action) => {
          state.postApplicationsInsurancePromocode.loading = false;
          state.postApplicationsInsurancePromocode.data = action.payload;
        }
      )
      .addCase(postApplicationsInsurancePromocode.rejected, (state, action) => {
        state.postApplicationsInsurancePromocode.loading = false;
        state.postApplicationsInsurancePromocode.error =
          action.error.message || "Неизвестная ошибка";
      })

      //postApplicationsInsurancePwd
      .addCase(postApplicationsInsurancePwd.pending, (state) => {
        state.postApplicationsInsurancePwd.loading = true;
        state.postApplicationsInsurancePwd.error = null;
      })
      .addCase(postApplicationsInsurancePwd.fulfilled, (state, action) => {
        state.postApplicationsInsurancePwd.loading = false;
        state.postApplicationsInsurancePwd.data = action.payload;
      })
      .addCase(postApplicationsInsurancePwd.rejected, (state, action) => {
        state.postApplicationsInsurancePwd.loading = false;
        state.postApplicationsInsurancePwd.error =
          action.error.message || "Неизвестная ошибка";
      })

      //postApplicationsChangeDistance
      .addCase(postApplicationsChangeDistance.pending, (state) => {
        state.postApplicationsChangeDistance.loading = true;
        state.postApplicationsChangeDistance.error = null;
      })
      .addCase(postApplicationsChangeDistance.fulfilled, (state, action) => {
        state.postApplicationsChangeDistance.loading = false;
        state.postApplicationsChangeDistance.data = action.payload;
      })
      .addCase(postApplicationsChangeDistance.rejected, (state, action) => {
        state.postApplicationsChangeDistance.loading = false;
        state.postApplicationsChangeDistance.error =
          action.error.message || "Неизвестная ошибка";
      })

      //postApplicationsMarathonMark
      .addCase(postApplicationsMarathonMark.pending, (state) => {
        state.postApplicationsMarathonMark.loading = true;
        state.postApplicationsMarathonMark.error = null;
      })
      .addCase(postApplicationsMarathonMark.fulfilled, (state, action) => {
        state.postApplicationsMarathonMark.loading = false;
        state.postApplicationsMarathonMark.data = action.payload;
      })
      .addCase(postApplicationsMarathonMark.rejected, (state, action) => {
        state.postApplicationsMarathonMark.loading = false;
        state.postApplicationsMarathonMark.error =
          action.error.message || "Неизвестная ошибка";
      })

      //postApplicationsMarathonUnmark
      .addCase(postApplicationsMarathonUnmark.pending, (state) => {
        state.postApplicationsMarathonUnmark.loading = true;
        state.postApplicationsMarathonUnmark.error = null;
      })
      .addCase(postApplicationsMarathonUnmark.fulfilled, (state, action) => {
        state.postApplicationsMarathonUnmark.loading = false;
        state.postApplicationsMarathonUnmark.data = action.payload;
      })
      .addCase(postApplicationsMarathonUnmark.rejected, (state, action) => {
        state.postApplicationsMarathonUnmark.loading = false;
        state.postApplicationsMarathonUnmark.error =
          action.error.message || "Неизвестная ошибка";
      })

      //getApplicationsById
      .addCase(getApplicationsById.pending, (state) => {
        state.getApplicationsById.response.loading = true;
        state.getApplicationsById.response.error = null;
      })
      .addCase(getApplicationsById.fulfilled, (state, action) => {
        state.getApplicationsById.response.loading = false;
        state.getApplicationsById.response.data = action.payload;
      })
      .addCase(getApplicationsById.rejected, (state, action) => {
        state.getApplicationsById.response.loading = false;
        state.getApplicationsById.response.error =
          action.error.message || "Неизвестная ошибка";
      })

      //deleteApplicationById
      .addCase(deleteApplicationById.pending, (state) => {
        state.deleteApplicationById.response.loading = true;
        state.deleteApplicationById.response.error = null;
      })
      .addCase(deleteApplicationById.fulfilled, (state, action) => {
        state.deleteApplicationById.response.loading = false;
        state.deleteApplicationById.response.data = true;
      })
      .addCase(deleteApplicationById.rejected, (state, action) => {
        state.deleteApplicationById.response.loading = false;
        state.deleteApplicationById.response.error =
          action.error.message || "Неизвестная ошибка";
      })

      //getApplicationsMarathonIndividualIssuance
      .addCase(getApplicationsMarathonIndividualIssuance.pending, (state) => {
        state.getApplicationsMarathonIndividualIssuance.response.loading = true;
        state.getApplicationsMarathonIndividualIssuance.response.error = null;
      })
      .addCase(
        getApplicationsMarathonIndividualIssuance.fulfilled,
        (state, action) => {
          state.getApplicationsMarathonIndividualIssuance.response.loading =
            false;
          state.getApplicationsMarathonIndividualIssuance.response.data =
            action.payload;
        }
      )
      .addCase(
        getApplicationsMarathonIndividualIssuance.rejected,
        (state, action) => {
          state.getApplicationsMarathonIndividualIssuance.response.loading =
            false;
          state.getApplicationsMarathonIndividualIssuance.response.error =
            action.error.message || "Неизвестная ошибка";
        }
      )

      //getApplicationsMarathonCorporateIssuance
      .addCase(getApplicationsMarathonCorporateIssuance.pending, (state) => {
        state.getApplicationsMarathonCorporateIssuance.response.loading = true;
        state.getApplicationsMarathonCorporateIssuance.response.error = null;
      })
      .addCase(
        getApplicationsMarathonCorporateIssuance.fulfilled,
        (state, action) => {
          state.getApplicationsMarathonCorporateIssuance.response.loading =
            false;
          state.getApplicationsMarathonCorporateIssuance.response.data =
            action.payload;
        }
      )
      .addCase(
        getApplicationsMarathonCorporateIssuance.rejected,
        (state, action) => {
          state.getApplicationsMarathonCorporateIssuance.response.loading =
            false;
          state.getApplicationsMarathonCorporateIssuance.response.error =
            action.error.message || "Неизвестная ошибка";
        }
      )

      //getApplicationsMarathonsExcel
      .addCase(getApplicationsMarathonsExcel.pending, (state) => {
        state.getApplicationsMarathonsExcel.response.loading = true;
        state.getApplicationsMarathonsExcel.response.error = null;
      })
      .addCase(getApplicationsMarathonsExcel.fulfilled, (state, action) => {
        state.getApplicationsMarathonsExcel.response.loading = false;
        state.getApplicationsMarathonsExcel.response.data = action.payload;
      })
      .addCase(getApplicationsMarathonsExcel.rejected, (state, action) => {
        state.getApplicationsMarathonsExcel.response.loading = false;
        state.getApplicationsMarathonsExcel.response.error =
          action.error.message || "Неизвестная ошибка";
      })

      //getMyApplications
      .addCase(getMyApplications.pending, (state) => {
        state.getMyApplications.response.loading = true;
        state.getMyApplications.response.error = null;
      })
      .addCase(getMyApplications.fulfilled, (state, action) => {
        state.getMyApplications.response.loading = false;
        state.getMyApplications.response.data = action.payload;
      })
      .addCase(getMyApplications.rejected, (state, action) => {
        state.getMyApplications.response.loading = false;
        state.getMyApplications.response.error =
          action.error.message || "Неизвестная ошибка";
      })

      //getApplicationsMarathonPublic
      .addCase(getApplicationsMarathonPublic.pending, (state) => {
        state.getApplicationsMarathonPublic.response.loading = true;
        state.getApplicationsMarathonPublic.response.error = null;
      })
      .addCase(getApplicationsMarathonPublic.fulfilled, (state, action) => {
        state.getApplicationsMarathonPublic.response.loading = false;
        state.getApplicationsMarathonPublic.response.data = action.payload;
      })
      .addCase(getApplicationsMarathonPublic.rejected, (state, action) => {
        state.getApplicationsMarathonPublic.response.loading = false;
        state.getApplicationsMarathonPublic.response.error =
          action.error.message || "Неизвестная ошибка";
      })

      //putApplicationsMarathonExcel
      .addCase(putApplicationsMarathonExcel.pending, (state) => {
        state.putApplicationsMarathonExcel.loading = true;
        state.putApplicationsMarathonExcel.error = null;
      })
      .addCase(putApplicationsMarathonExcel.fulfilled, (state, action) => {
        state.putApplicationsMarathonExcel.loading = false;
        state.putApplicationsMarathonExcel.data = action.payload;
      })
      .addCase(putApplicationsMarathonExcel.rejected, (state, action) => {
        state.putApplicationsMarathonExcel.loading = false;
        state.putApplicationsMarathonExcel.error =
          action.error.message || "Неизвестная ошибка";
      })
});

export default applicationsSlice.reducer;
